import React, { useEffect, useState } from "react";
import { Button, Card, Form, InputNumber, Typography, Spin, Alert } from "antd";
import { SaveOutlined, DollarOutlined } from "@ant-design/icons";
import axios from "axios";

const { Title, Text } = Typography;
const API_URL = process.env.REACT_APP_API_URL;

export default function FrmConfigLeche() {
  const [form] = Form.useForm();
  const [cargando, setCargando] = useState(false);
  const [guardando, setGuardando] = useState(false);
  const [resultado, setResultado] = useState(null);

  useEffect(() => {
    const cargar = async () => {
      try {
        setCargando(true);
        const resp = await axios.get(`${API_URL}/ConfigLeche`);
        const d = resp.data;
        form.setFieldsValue({
          precioPorLitro: d?.precioPorLitro ?? d?.PrecioPorLitro ?? 0,
          observacion: d?.observacion ?? d?.Observacion ?? "",
        });
      } catch {
        setResultado({ tipo: "error", texto: "No se pudo cargar la configuración." });
      } finally {
        setCargando(false);
      }
    };
    cargar();
  }, [form]);

  const onGuardar = async () => {
    try {
      const values = await form.validateFields();
      setGuardando(true);
      setResultado(null);
      await axios.put(`${API_URL}/ConfigLeche`, {
        precioPorLitro: values.precioPorLitro,
        fechaVigencia: new Date().toISOString().split("T")[0],
        observacion: values.observacion || null,
      });
      setResultado({
        tipo: "success",
        texto: `✅ Precio actualizado a $${Number(values.precioPorLitro).toLocaleString()} por litro.`,
      });
    } catch (err) {
      if (err?.errorFields) return;
      setResultado({ tipo: "error", texto: "Error al guardar. Verifique el backend." });
    } finally {
      setGuardando(false);
    }
  };

  return (
    <div style={{ padding: 16, maxWidth: 520 }}>
      <Title level={3}>
        <DollarOutlined style={{ marginRight: 8 }} />
        Precio de Leche por Litro
      </Title>
      <Text type="secondary">
        Configure el precio que le pagan por cada litro de leche.
        Este valor se usará en los informes de estadísticas y producción por vaca
        para calcular el ingreso total.
      </Text>

      {resultado && (
        <Alert
          type={resultado.tipo}
          message={resultado.texto}
          showIcon
          closable
          onClose={() => setResultado(null)}
          style={{ marginTop: 16 }}
        />
      )}

      <Card style={{ marginTop: 16 }}>
        <Spin spinning={cargando}>
          <Form form={form} layout="vertical">
            <Form.Item
              label="Precio por litro ($)"
              name="precioPorLitro"
              rules={[{ required: true, message: "Ingrese el precio por litro." }]}
            >
              <InputNumber
                min={0}
                step={100}
                style={{ width: "100%" }}
                placeholder="Ej: 1200"
                formatter={v => v ? `$ ${v}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",") : ""}
                parser={v => v.replace(/\$\s?|(,*)/g, "")}
                size="large"
              />
            </Form.Item>
            <Form.Item label="Observación (opcional)" name="observacion">
              <input
                style={{ width: "100%", padding: "4px 11px", border: "1px solid #d9d9d9", borderRadius: 6 }}
                placeholder="Ej: Tarifa cooperativa mayo 2026"
              />
            </Form.Item>
            <Button
              type="primary"
              icon={<SaveOutlined />}
              onClick={onGuardar}
              loading={guardando}
              size="large"
              block
            >
              Guardar precio
            </Button>
          </Form>
        </Spin>
      </Card>
    </div>
  );
}
